/* eslint-disable no-unused-vars */
import React, { useState, useContext } from 'react';
import { ColorContext } from '../context/ColorContext';
import { apiUrl } from '../../config/config';
import { useNavigate } from 'react-router-dom';
import { refreshCartCount } from '../../utils/cartCount';

const ExportButton = ({
  productName,
  pid,
  totalQuantity,
  canvasOne,       // Front canvas
  canvasTwo,       // Back canvas
  canvasThree,     // Sleeves canvas
  canvasFour,
  extractColorsFromObject,
  selectedFont,
  Canvasid,
  totalPrice,
  basePrice,
  zipCode,
  designName,
  email,
  mcategory,
  uniqueKey,
  selcolor,
  standardDeliveryDate,
  superRushDate,
  rushDate,
  orderType,
  sale_price,
  addressPreview,
  totalCanvasPrice,
  handleMockupContinue,
  disabled = false,
  imagecaptureFront,
  imagecaptureBack,
  imagecaptureRight,
  imagecaptureLeft,
  availableSizes = [],
  availablePartNames = ['Front', 'Back', 'Right', 'Left'],
}) => {
  const { selectedColor } = useContext(ColorContext);
  const [inkColors, setInkColors] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [clipArtPreviews, setClipArtPreviews] = useState([]);
  const [loading, setLoading] = useState(false);  // Add loading state
 console.log("selcolor:",selectedColor);
 const numcolor = localStorage.getItem("numcolor")
 console.log("numcolor",numcolor);
  const navigate = useNavigate();
  const getCanvasByPartName = (partName) => {
    switch (partName) {
      case 'Front':
        return canvasOne;
      case 'Back':
        return canvasTwo;
      case 'Right':
        return canvasThree;
      case 'Left':
        return canvasFour;
      default:
        return null;
    }
  };

  const filterColors = (colors) => {
    return colors.filter(color =>
      color !== 'transparent' &&
      color !== 'rgb(0,0,0)' &&
      color !== 'rgba(0,0,0,0)' &&
      color !== 'rgba(150, 150, 150, 1)' &&
      color !== 'none' &&
      color !== selectedColor // Exclude the product color from ink colors
    );
  };

  console.log("addressPreview", addressPreview);
  console.log(' pid', pid);
  const queryString = window.location.search; // Gets the query string, e.g., "?id=ts-rn-hs-02"

  const params = new URLSearchParams(queryString); 
  const influencerid = params.get('influencerid');
  const sellerprodid = params.get('sellerprodid');


console.log("totalCanvasPrice", totalCanvasPrice);



  const extractAndPreviewColors = () => {
    const colorsSet = new Set();

    // Extract colors from objects, but only if the object has non-zero opacity
    availablePartNames.forEach((partName) => {
      const canvas = getCanvasByPartName(partName);
      if (canvas) {
        canvas.getObjects().forEach((obj) => {
          if (obj.opacity !== 0) { // Ensure the object is visible
            extractColorsFromObject(obj).forEach(color => colorsSet.add(color));
          }
        });
      }
    });

    const filteredColors = filterColors(Array.from(colorsSet));
    setInkColors(filteredColors);
  };



  const generateImagePreviews = () => {
    const previews = [];
    const clipArtPreviews = [];

    // Capture both image and clip art objects
    const captureCanvasImage = (canvas, part) => {
      if (canvas && canvas.getObjects().length > 0) {
        // Render the canvas to ensure the latest state
        canvas.renderAll();

        // Capture the canvas image as base64
        const preview = canvas.toDataURL('image/png');
        previews.push({ part, preview });

        // Loop through objects to capture clip art and images separately
        canvas.getObjects().forEach((obj) => {
          if (obj.designElement && obj.clipartPath && obj.opacity !== 0) {
            // Capture clip art
            const clipArtCanvas = document.createElement('canvas');
            clipArtCanvas.width = obj.width * obj.scaleX;
            clipArtCanvas.height = obj.height * obj.scaleY;
            const ctx = clipArtCanvas.getContext('2d');
            obj.render(ctx);
            clipArtPreviews.push({
              clipartPath: obj.clipartPath,
              part,
              preview: clipArtCanvas.toDataURL('image/png')
            });

            console.log('clipArtCanvas',clipArtCanvas);

          
          } else if (obj.type === 'image' && obj.opacity !== 0) {
            // Capture uploaded images
            const imageCanvas = document.createElement('canvas');
            imageCanvas.width = obj.width * obj.scaleX;
            imageCanvas.height = obj.height * obj.scaleY;
            const ctx = imageCanvas.getContext('2d');
            obj.render(ctx);
            previews.push({
              part,
              preview: imageCanvas.toDataURL('image/png')
            });
          }
        });
      } else {
        previews.push({ part, preview: null });
      }
    };

    availablePartNames.forEach((partName) => {
      captureCanvasImage(getCanvasByPartName(partName), partName);
    });

    // Set the previews for display
    setImagePreviews(previews);
    setClipArtPreviews(clipArtPreviews);
  };

  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const exportJSON = async () => {
    const isSellerProduct = !!sellerprodid;

    if (!isSellerProduct) {
      if (!designName.trim()) {
        alert("Design Name is required.");
        return;
      }
    
      if (!email.trim()) {
        alert("Email is required.");
        return;
      }
    
      if (!validateEmail(email)) {
        alert("Invalid email format. Please enter a valid email address.");
        return;
      }
    }
    
  
  
    setLoading(true);  // Set loading to true when starting the export
    

    const colorsSet = new Set();
    const fontsSet = new Set();
    const clipArtData = [];
    const uploadedImageData = [];
    const uniqueClipartPaths = new Set();
    const uniqueImageSources = new Set();

    const partColors = availablePartNames.reduce((acc, partName) => {
      acc[partName] = new Set();
      return acc;
    }, {});
    
    availablePartNames.forEach((part) => {
      const canvas = getCanvasByPartName(part);
      if (canvas) {
        canvas.getObjects().forEach((obj) => {
          if (obj.opacity !== 0) { // Ensure the object is visible
            // Extract colors and add to the corresponding part
            extractColorsFromObject(obj).forEach((color) => partColors[part].add(color));
    
            // Collect font information for text paths
            if (obj.type === 'path' && obj.fontFamily) {
              fontsSet.add(obj.fontFamily);
            }
    
            // Collect clip art data
              if (obj.type === 'group' && obj.opacity !== 0 && obj.clipartPath) {
                if (!uniqueClipartPaths.has(obj.clipartPath)) {
                  uniqueClipartPaths.add(obj.clipartPath); // Add to the Set
                  clipArtData.push({
                    clipartPath: obj.clipartPath,
                    part,
                    width: obj.width * obj.scaleX,
                    height: obj.height * obj.scaleY,
                    left: obj.left,
                    top: obj.top,
                    scaleX: obj.scaleX,
                    scaleY: obj.scaleY,
                  });
                }
              }
          
    
            // Collect uploaded image data
            if (obj.type === 'image' && obj.opacity !== 0 && obj.getSrc()) {
              if (!uniqueImageSources.has(obj.getSrc())) {
                uniqueImageSources.add(obj.getSrc()); // Add to the Set
                uploadedImageData.push({
                  imageSrc: obj.getSrc(),
                  part,
                  width: obj.width * obj.scaleX,
                  height: obj.height * obj.scaleY,
                  left: obj.left,
                  top: obj.top,
                  scaleX: obj.scaleX,
                  scaleY: obj.scaleY,
                });
              }
            }
          }
        });
      }
    });
    
    // Convert partColors Sets to Arrays for easier manipulation
const structuredColors = Object.fromEntries(
  Object.entries(partColors).map(([part, colorsSet]) => [
    part, 
    filterColors(Array.from(colorsSet)) // Apply the filterColors function here
  ])
);

console.log("Filtered Structured Colors by Part:", structuredColors);
    
    const filteredColors = filterColors(Array.from(colorsSet));

    console.log('filterColorsss',filteredColors);
    const selectedFonts = Array.from(fontsSet); // Convert the Set of fonts to an array
  
    // Retrieve the quantities from local storage
    const storedQuantities = JSON.parse(localStorage.getItem(uniqueKey)) || {};
    
    const allQuantities = availableSizes.length > 0
      ? availableSizes.reduce((acc, size) => {
          acc[size] = Number(storedQuantities[size]) || 0;
          return acc;
        }, {})
      : storedQuantities;
  
    // Include all canvas images (front, back, sleeves) in the export data
    const imagePreviews = availablePartNames
      .map((part) => {
        const canvas = getCanvasByPartName(part);
        return canvas ? { part, preview: canvas.toDataURL('image/jpg') } : null;
      })
      .filter(Boolean); // Filter out any null values
  
    // Calculate unitPrice
    const unitPrice = totalQuantity > 0 ? (totalPrice / totalQuantity).toFixed(2) : basePrice;
    const userId = parseInt(localStorage.getItem("Id"));
    console.log("imagePreviews",imagePreviews);
    const imageUrls = await uploadImages(imagePreviews);

    console.log("imagePreviews",imagePreviews);

    // Determine how many unique sides are used: Front, Back, Right, Left
// Define valid sides

const sides = availablePartNames;

const safeStructuredColors = structuredColors || {};
const safeClipArtData = Array.isArray(clipArtData) ? clipArtData : [];

const usedScreens = sides.filter((side) => {
  const inkArray = safeStructuredColors?.[side];
  const hasInkColor = Array.isArray(inkArray) && inkArray.length > 0;
  const hasClipArt = safeClipArtData.some((clip) => clip?.part === side);

  console.log(`SIDE: ${side} → hasInkColor:`, hasInkColor, "| hasClipArt:", hasClipArt);
  return hasInkColor || hasClipArt;
});

console.log("FINAL Used Screens:", usedScreens);

// Count how many sides are used
const screenCount = usedScreens.length;

// Define price rules
const screenPrintingPrices = {
  1: 20,
  2: 30,
  3: 40,
  4: 50,
};

const embroideryPrices = {
  1: 25,
  2: 35,
  3: 45,
  4: 55,
};

// Pick correct price map based on orderType
const priceMap =
  orderType === "embroidery" ? embroideryPrices : screenPrintingPrices;

// Calculate PO price
const poUnitPrice = priceMap[screenCount] || 0;
const poTotalPrice = poUnitPrice * totalQuantity;

console.log("Order Type:", orderType);
console.log("PO Unit Price:", poUnitPrice);
console.log("PO Total Price:", poTotalPrice);

    // Export data with clip art and uploaded images included
    const uploadedImageUrls = await uploadUploadedImages(uploadedImageData);

    const exportData = {
      productName,
      userId,
      product_id:parseInt(pid),
      garment: mcategory,
      Email: email,
      designName,
      zipCode,
      state_name:addressPreview,
      canvasId: Canvasid,               
      productColor: selcolor,
      selectedFonts,                    
      inkColors: structuredColors,
      quantities: allQuantities,   
      totalQuantity,                    
      totalPrice, 
      unitPrice,                        
      basePrice,                        
      imagePreviews: imageUrls,                   
      clipArtData,                      
      uploadedImageData: uploadedImageUrls,
      orderType: orderType,
      sale_price,
      canvas_price: totalCanvasPrice.toString(),
      Delivery_date: {
        standard: standardDeliveryDate,
        rush: rushDate,
        superRush: superRushDate
      }              
    };


    const exportDataSeller = {
      selectedFonts,
      inkColors: structuredColors,
      clipArtData,
      uploadedImageData: uploadedImageUrls,
      seller_prod_id: parseInt(sellerprodid),
      orderType: orderType,
      po_price: poTotalPrice.toString(),

  
    };
  
    console.log("imageUrls", imageUrls);
    try {
      const isSellerProduct = !!sellerprodid;
    
    
      const apiUrls = isSellerProduct
        ? `${apiUrl}/api/checkout-seller`
        : `${apiUrl}/api/checkouts`;
    
      const response = await fetch(apiUrls, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(isSellerProduct ? exportDataSeller : exportData),
      });
    
      if (response.ok) {
        setLoading(false);
        if (!isSellerProduct) refreshCartCount();
    
        if (isSellerProduct && handleMockupContinue) {
          await handleMockupContinue(); // 🔁 Wait for mockup generation
          

         
            window.open(`https://dashboard.inkox.com/apps/ecommerce/unpublish-detail?id=${sellerprodid}&mode=edit`, "_blank");
         
          
          
        } else {
          navigate("/cart");
        }
      } else {
        console.error('Failed to post data to the API');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error while posting data to the API:', error);
      setLoading(false);
    }
    
    
  

  };
  
  const uploadImages = async (imagePreviews) => {
    const uploadedImages = await Promise.all(imagePreviews.map(async (image) => {
      if (image && image.preview) {
        const compressedImage = await compressImage(image.preview, 20000); // Compress to ~20KB
        const blob = await (await fetch(compressedImage)).blob(); // Convert base64 to blob
        const formData = new FormData();
        formData.append('image', blob, `${image.part}.webp`);
  
        try {
          const response = await fetch(`${apiUrl}/api/upload-image`, {
            method: 'POST',
            body: formData,
          });
  
          const result = await response.json();
          return { part: image.part, preview: result.imageUrl }; // Return the uploaded image URL
        } catch (error) {
          console.error(`Failed to upload image for ${image.part}:`, error);
          return { part: image.part, preview: null }; // Return null if upload fails
        }
      }
      return { part: image.part, preview: null }; // Return null if no image
    }));
  
    return uploadedImages.filter(img => img.preview !== null); // Filter out any failed uploads
  };

  const uploadUploadedImages = async (uploadedImageData) => {
    const uploadedImages = await Promise.all(uploadedImageData.map(async (image) => {
      if (image && image.imageSrc) {
        try {
          // Compress the image (this is assuming image.imageSrc is a base64 string)
          const compressedImage = await compressImage(image.imageSrc, 1000); // Compress to ~20KB
  
          // Convert base64 string to blob
          const blob = await (await fetch(compressedImage)).blob();
  
          // Create a FormData object and append the image blob
          const formData = new FormData();
          formData.append('image', blob, `${image.part}.webp`);
  
          // Make the API call to upload the image
          const response = await fetch(`${apiUrl}/api/upload-image`, {
            method: 'POST',
            body: formData,
          });
  
          const result = await response.json();
          
          // Return the uploaded image URL
          return { part: image.part, preview: result.imageUrl };
        } catch (error) {
          console.error(`Failed to upload image for ${image.part}:`, error);
          return { part: image.part, preview: null };
        }
      }
  
      // Return null if no image is found
      return { part: image.part, preview: null };
    }));
  
    return uploadedImages.filter(img => img.preview !== null); // Filter out any failed uploads
  };
  
  

  const compressImage = (base64Str, maxFileSizeInBytes) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";  // Allow cross-origin images to be loaded
      img.src = base64Str;
  
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
  
        const MAX_WIDTH = 800; // Adjust the max width as needed
        const scaleSize = MAX_WIDTH / img.width;
        canvas.width = MAX_WIDTH;
        canvas.height = img.height * scaleSize;
  
        // Draw the image onto the canvas
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  
        // Extract the base64 string portion
        const base64Image = base64Str.split(',')[1];
  
        if (!base64Image) {
          return reject(new Error('Failed to extract base64 string from the provided image URL.'));
        }
  
        // Log initial image size in KB
        let originalSize = (base64Image.length * (3 / 4)) / 1024; // Approximate size in KB
        console.log(`Original image size: ${originalSize} KB`);
  
        // Compress the image
        let quality = 0.7; // Start with a balance between quality and compression
        let compressedDataUrl = canvas.toDataURL('image/webp', quality);
        let compressedBase64Image = compressedDataUrl.split(',')[1]; // Extract base64 string
        let compressedSize = (compressedBase64Image.length * (3 / 4)) / 1024; // Approximate size in KB
  
        console.log(`Initial compressed size: ${compressedSize} KB`);
  
        // Loop to adjust quality and reduce size
        while (compressedSize > maxFileSizeInBytes / 1024 && quality > 0.1) {
          quality -= 0.1; // Reduce quality for more compression
          compressedDataUrl = canvas.toDataURL('image/webp', quality);
          compressedBase64Image = compressedDataUrl.split(',')[1]; // Extract base64 string
          compressedSize = (compressedBase64Image.length * (3 / 4)) / 1024; // Recalculate size
          console.log(`Compressed size at quality ${quality}: ${compressedSize} KB`);
        }
  
        // If we couldn't reach the desired size, log and reject or resolve with the best possible quality
        if (compressedSize > maxFileSizeInBytes / 1024) {
          console.warn('Could not compress image to desired size.');
          resolve(compressedDataUrl); // Resolve with the smallest possible image
        } else {
          resolve(compressedDataUrl); // Resolve with the properly compressed image
        }
      };
  
      img.onerror = (err) => {
        console.error('Image load error:', err);
        reject(err);
      };
    });
  };
  
  
  
  

  // Function to upload user-uploaded image data


// Function to compress images


  return (
    <div>
      {/* <button onClick={extractAndPreviewColors} className="preview-button">
        Preview Ink Colors
      </button>
      <div className="color-preview">
        {inkColors.map((color, index) => (
          <div
            key={index}
            style={{
              backgroundColor: color,
              width: '30px',
              height: '30px',
              display: 'inline-block',
              margin: '5px',
            }}
            title={color}
          ></div>
        ))}
      </div>
      
      <button onClick={generateImagePreviews} className="preview-button">
        Preview Images & Clip Art
      </button>
      <div className="image-preview">
        {imagePreviews.map((image, index) => (
          <div key={index}>
            <h4>{image.part}</h4>
            <img
              src={image.preview}
              alt={`Preview of ${image.part}`}
              style={{
                width: '100px',
                height: '100px',
                display: 'inline-block',
                margin: '5px',
              }}
            />
          </div>
        ))}
      </div>
      <div className="clipart-preview">
        {clipArtPreviews.map((clipArt, index) => (
          <div key={index}>
            <h4>Clip Art - {clipArt.part}</h4>
            <img
              src={clipArt.preview}
              alt={`Clip Art on ${clipArt.part}`}
              style={{
                width: '100px',
                height: '100px',
                display: 'inline-block',
                margin: '5px',
              }}
            />
          </div>
        ))}
      </div> */}
     {loading && !sellerprodid ? (
  <div className="loader">
    <div className="spinner"></div>
    Just a moment! We're adding your product to the cart.
  </div>
) 
 : (
      
        <button onClick={exportJSON} className="export-button continue-btn"   disabled={loading || disabled}
        
        
        style={{
          cursor: loading || disabled ? 'not-allowed' : 'pointer',
        }}>
        {loading
          ? (sellerprodid ? 'Redirecting to Dashboard' : 'Adding to cart...')
          : (sellerprodid ? 'Continue to Mockups' : 'Add to Cart')}
      </button>
     
      

)}
    </div>
  );
};

export default ExportButton;
